module.exports = __webpack_public_path__ + "img/TZS09381.1debc80e.jpeg";